import React, { Component } from "react";
import Header from "../components/header";
import Footer from "../components/footer";
import { Link } from "react-router-dom";
import "./investments.css"; // Ensure this file exists

class Investments extends Component {
  render() {
    return (
      <div>
        <Header />
        <div className="our-team-hero">
          <div className="overlay"></div>
          <div className="hero-content container">
            <h1>Cultivation  Reward</h1>
            <div className="breadcrumb">
              <Link to="/" className="breadcrumb-home">Home</Link>
              <span className="breadcrumb-active"> / Cultivation Reward  </span>
            </div>
          </div>
        </div>
        
        <div className="pt-5">
                  
                  <div className="container text-start" >

                  <p style={{ paddingTop: "20px" }}></p>
            <p style={{ paddingTop: "20px" }}></p>
                    
                  <div className="text-center"> 
             <h1 className="" style={{fontWeight:"800"}}> Wealth System Reward </h1>
              
        
            <div className="site-text-color pb-4" style={{marginTop:"-5px",fontSize:"20px"}}>
            Cultivation Rewards Based on Task Accomplishment Levels
            </div>
          
            <label className="text-left" style={{ textAlign: "justify" }}>
            The following table represents accurate cultivation rewards from the system at different percentage level of task 
accomplishment on wealth System platform before necessary deductions upon cash out request depending on the Country one is 
cultivating from. (All things being equal)
            <br></br>
            <p style={{ paddingTop: "20px" }}></p>
            <p style={{ paddingTop: "20px" }}></p>
            </label>
        </div>


                    <div className="row">
                    <div className="col-lg-10 col-md-12 col-sm-12 about-text " style={{textAlign:"justify"}}>
                      <b style={{backgroundColor:"#79dc3f", padding:"10px 20px", overflow:"auto", borderRadius:"8px 8px 0px 0px"}}>Investment Levels & Earnings Breakdown </b>
                      <div className=" " style={{backgroundColor:"#79dc3f", padding:"20px", overflow:"auto",  borderRadius:" 0px 8px 8px 8px"}}>
                      <img src="table-ngn.png" style={{width:"100%"}}/>
                      </div>
                    </div>
                  
                  
                  </div>
                  
                  </div>
          </div>


          <div className="pt-5">
                  
                  <div className="container text-start" >


                    <div className="row">
                    <div className="col-lg-10 col-md-12 col-sm-12 about-text " style={{textAlign:"justify"}}>
                      <b style={{backgroundColor:"#79dc3f", padding:"10px 20px", overflow:"auto", borderRadius:"8px 8px 0px 0px"}}>1st Investment Realm (N1,000 ) </b>
                      <div className=" " style={{backgroundColor:"#79dc3f", padding:"20px", overflow:"auto",  borderRadius:" 0px 8px 8px 8px"}}>
                      <img src="table-ngn-realm/table-ngn - 1st realm.png" style={{width:"100%"}}/>
                      </div>
                    </div>

                    <div className="col-lg-10 col-md-12 col-sm-12 about-text " style={{textAlign:"justify"}}>
                    <p style={{ paddingTop: "20px" }}></p>
                      <b style={{backgroundColor:"#79dc3f", padding:"10px 20px", overflow:"auto", borderRadius:"8px 8px 0px 0px"}}>2nd Investment Realm (N2,500 ) </b>
                      <div className=" " style={{backgroundColor:"#79dc3f", padding:"20px", overflow:"auto",  borderRadius:" 0px 8px 8px 8px"}}>
                      <img src="table-ngn-realm/table-ngn - 2nd realm.png" style={{width:"100%"}}/>
                      </div>
                    </div>

                    <div className="col-lg-10 col-md-12 col-sm-12 about-text " style={{textAlign:"justify"}}>
                    <p style={{ paddingTop: "20px" }}></p>
                      <b style={{backgroundColor:"#79dc3f", padding:"10px 20px", overflow:"auto", borderRadius:"8px 8px 0px 0px"}}>3rd Investment Realm (N5,000 ) </b>
                      <div className=" " style={{backgroundColor:"#79dc3f", padding:"20px", overflow:"auto",  borderRadius:" 0px 8px 8px 8px"}}>
                      <img src="table-ngn-realm/table-ngn - 3rd realm.png" style={{width:"100%"}}/>
                      </div>
                    </div>

                    <div className="col-lg-10 col-md-12 col-sm-12 about-text " style={{textAlign:"justify"}}>
                    <p style={{ paddingTop: "20px" }}></p>
                      <b style={{backgroundColor:"#79dc3f", padding:"10px 20px", overflow:"auto", borderRadius:"8px 8px 0px 0px"}}>4th Investment Realm (N10,000 ) </b>
                      <div className=" " style={{backgroundColor:"#79dc3f", padding:"20px", overflow:"auto",  borderRadius:" 0px 8px 8px 8px"}}>
                      <img src="table-ngn-realm/table-ngn - 4th realm.png" style={{width:"100%"}}/>
                      </div>
                    </div>

                    <div className="col-lg-10 col-md-12 col-sm-12 about-text " style={{textAlign:"justify"}}>
                    <p style={{ paddingTop: "20px" }}></p>
                      <b style={{backgroundColor:"#79dc3f", padding:"10px 20px", overflow:"auto", borderRadius:"8px 8px 0px 0px"}}>5th Investment Realm (N15,000 ) </b>
                      <div className=" " style={{backgroundColor:"#79dc3f", padding:"20px", overflow:"auto",  borderRadius:" 0px 8px 8px 8px"}}>
                      <img src="table-ngn-realm/table-ngn - 5th realm.png" style={{width:"100%"}}/>
                      </div>
                    </div>

                    <div className="col-lg-10 col-md-12 col-sm-12 about-text " style={{textAlign:"justify"}}>
                    <p style={{ paddingTop: "20px" }}></p>
                      <b style={{backgroundColor:"#79dc3f", padding:"10px 20px", overflow:"auto", borderRadius:"8px 8px 0px 0px"}}>6th Investment Realm (N20,000 ) </b>
                      <div className=" " style={{backgroundColor:"#79dc3f", padding:"20px", overflow:"auto",  borderRadius:" 0px 8px 8px 8px"}}>
                      <img src="table-ngn-realm/table-ngn - 6th realm.png" style={{width:"100%"}}/>
                      </div>
                    </div>

                    <div className="col-lg-10 col-md-12 col-sm-12 about-text " style={{textAlign:"justify"}}>
                    <p style={{ paddingTop: "20px" }}></p>
                      <b style={{backgroundColor:"#79dc3f", padding:"10px 20px", overflow:"auto", borderRadius:"8px 8px 0px 0px"}}>7th Investment Realm (N25,000 ) </b>
                      <div className=" " style={{backgroundColor:"#79dc3f", padding:"20px", overflow:"auto",  borderRadius:" 0px 8px 8px 8px"}}>
                      <img src="table-ngn-realm/table-ngn - 7th realm.png" style={{width:"100%"}}/>
                      </div>
                    </div>

                    <div className="col-lg-10 col-md-12 col-sm-12 about-text " style={{textAlign:"justify"}}>
                    <p style={{ paddingTop: "20px" }}></p>
                      <b style={{backgroundColor:"#79dc3f", padding:"10px 20px", overflow:"auto", borderRadius:"8px 8px 0px 0px"}}>8th Investment Realm (N30,000 ) </b>
                      <div className=" " style={{backgroundColor:"#79dc3f", padding:"20px", overflow:"auto",  borderRadius:" 0px 8px 8px 8px"}}>
                      <img src="table-ngn-realm/table-ngn - 8th realm.png" style={{width:"100%"}}/>
                      </div>
                    </div>


                    <div className="col-lg-10 col-md-12 col-sm-12 about-text " style={{textAlign:"justify"}}>
                    <p style={{ paddingTop: "20px" }}></p>
                      <b style={{backgroundColor:"#79dc3f", padding:"10px 20px", overflow:"auto", borderRadius:"8px 8px 0px 0px"}}>9th Investment Realm (N35,000 ) </b>
                      <div className=" " style={{backgroundColor:"#79dc3f", padding:"20px", overflow:"auto",  borderRadius:" 0px 8px 8px 8px"}}>
                      <img src="table-ngn-realm/table-ngn - 9th realm.png" style={{width:"100%"}}/>
                      </div>
                    </div>


                    <div className="col-lg-10 col-md-12 col-sm-12 about-text " style={{textAlign:"justify"}}>
                    <p style={{ paddingTop: "20px" }}></p>
                      <b style={{backgroundColor:"#79dc3f", padding:"10px 20px", overflow:"auto", borderRadius:"8px 8px 0px 0px"}}>10th Investment Realm (N40,000 ) </b>
                      <div className=" " style={{backgroundColor:"#79dc3f", padding:"20px", overflow:"auto",  borderRadius:" 0px 8px 8px 8px"}}>
                      <img src="table-ngn-realm/table-ngn - 10th realm.png" style={{width:"100%"}}/>
                      </div>
                    </div>


                    <div className="col-lg-10 col-md-12 col-sm-12 about-text " style={{textAlign:"justify"}}>
                    <p style={{ paddingTop: "20px" }}></p>
                      <b style={{backgroundColor:"#79dc3f", padding:"10px 20px", overflow:"auto", borderRadius:"8px 8px 0px 0px"}}>11th Investment Realm (N45,000 ) </b>
                      <div className=" " style={{backgroundColor:"#79dc3f", padding:"20px", overflow:"auto",  borderRadius:" 0px 8px 8px 8px"}}>
                      <img src="table-ngn-realm/table-ngn - 11th realm.png" style={{width:"100%"}}/>
                      </div>
                    </div>

                    <div className="col-lg-10 col-md-12 col-sm-12 about-text " style={{textAlign:"justify"}}>
                    <p style={{ paddingTop: "20px" }}></p>
                      <b style={{backgroundColor:"#79dc3f", padding:"10px 20px", overflow:"auto", borderRadius:"8px 8px 0px 0px"}}>12th Investment Realm (N50,000 ) </b>
                      <div className=" " style={{backgroundColor:"#79dc3f", padding:"20px", overflow:"auto",  borderRadius:" 0px 8px 8px 8px"}}>
                      <img src="table-ngn-realm/table-ngn - 12th realm.png" style={{width:"100%"}}/>
                      </div>
                      <p style={{ paddingTop: "20px" }}></p>
                      <p style={{ paddingTop: "20px" }}></p>
                    </div>


                  
                  
                  </div>
                  
                  </div>
          </div>
          
        <Footer />
      </div>
    );
  }
}

export default Investments;
